import React, { useState } from "react";
import { Input, List } from "semantic-ui-react";

const SearchableList = ({ items }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredItems = items.filter((item) =>
    item.key.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  return (
    <div>
      <Input
        icon="search"
        placeholder="Search..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        fluid
        style={{
          borderRadius: "0.4rem",
          boxShadow: "0 1px 1px rgba(0, 0, 0, 0.2)",
        }}
      />
      <List
        selection
        animated
        celled
        style={{
          maxHeight: "25rem",
          overflowY: "auto",
          border: "1px solid #dcdcdc",
          borderRadius: "0.4rem",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.5)",
          marginBottom: "1.5rem",
        }}
      >
        {filteredItems.map((item, index) => (
          <List.Item
            key={index}
            style={{
              padding: "0.8rem",
              borderBottom: "1px solid #f0f0f0",
              cursor: "pointer",
              transition: "background-color 0.2s ease",
            }}
          >
            {item}
          </List.Item>
        ))}
      </List>
    </div>
  );
};

export default SearchableList;
